import { IsBoolean, IsString } from 'class-validator';
import { User } from '../../response';
import { BaseModel } from '../base-model';
import { EditUserModel } from './edit-user.model';

export class ChangeUserStatusModel extends EditUserModel implements BaseModel {
    @IsString({ message: 'Invalid id' })
    public Id: string = '';

    @IsBoolean({ message: 'Must be active or inactive' })
    public Status: boolean = false;

    constructor(user: User) {
        super(user);

        if (user) {
            this.Id = user.id;
            this.Status = user.account_Status;
            return;
        }
    }
}
